import { SortedRecommendationQuizResponses } from '../Providers/RecommendationsProvider';

export const getInterestTags = (quizResponses: SortedRecommendationQuizResponses) => {
	const interests = quizResponses.interests || [];
	const businessInterests = quizResponses.businessInterests.length
		? quizResponses.businessInterests
		: interests;
	const healthcareInterests = quizResponses.healthcareInterests.length
		? quizResponses.healthcareInterests
		: interests;
	const technologyInterests = quizResponses.techInterests.length
		? quizResponses.techInterests
		: interests;
	const nonHierarchicalTags = interests
		.filter(i => !i.includes('>') && !['Business', 'Healthcare', 'Technology'].includes(i))
		.map(i => {
			return `Interest: ${i}`;
		});
	const businessTags = businessInterests
		.filter(i => i.includes('Business >'))
		.map(i => {
			return `Interest:${i.replace('Business >', '')}`;
		});
	const healthcareTags = healthcareInterests
		.filter(i => i.includes('Healthcare >'))
		.map(i => {
			return `Interest:${i.replace('Healthcare >', '')}`;
		});
	const technologyTags = technologyInterests
		.filter(i => i.includes('Technology >'))
		.map(i => {
			return `Interest:${i.replace('Technology >', '')}`;
		});
	return [...nonHierarchicalTags, ...businessTags, ...healthcareTags, ...technologyTags];
};

export const getAnswerTags = (quizResponses: SortedRecommendationQuizResponses) => {
	if (!quizResponses) return [];

	const tags = [];

	if (quizResponses.goal) {
		tags.push(`Goal: ${quizResponses.goal}`);
	}

	if (quizResponses.education) {
		tags.push(`Qualifications: ${quizResponses.education}`);
	}

	if (quizResponses.weeklyTime) {
		tags.push(`Effort per week: ${quizResponses.weeklyTime}`);
	}

	if (quizResponses.timeToComplete) {
		tags.push(`Time to complete: ${quizResponses.timeToComplete}`);
	}

	if (quizResponses.collegeGpa) {
		const collegeNumber = quizResponses.collegeGpa.split('(')[0].trim();
		tags.push(`Qualifications: ${collegeNumber} college GPA`);
	}

	if (quizResponses.hsGpa) {
		const hsNumber = quizResponses.hsGpa.split('(')[0].trim();
		tags.push(`Qualifications: ${hsNumber} high school GPA`);
	}

	if (quizResponses.interests) {
		tags.push(...getInterestTags(quizResponses));
	}

	return tags
		.sort((a, b) => a.length - b.length)
		.map(v => {
			return { value: v, label: v };
		});
};
